namespace GeniuzPOS.Purchase {
    export class PoInvoiceReceiveColumns {
        static columnsKey = 'Purchase.PoInvoiceReceive';
    }
}
